<template>
  <div class="hello">
    <div style="text-align: center"><h1>(404) Page NotFound</h1></div>
  </div>
</template>

<script>
export default {};
</script>
